// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"37275328","453":"bda2321c","467":"6d9677bc","689":"5a61a5dd","756":"513bdb1e","869":"189ec9e6","900":"df74f713","925":"aec21725"}[chunkId] + ".chunk.js";
};